<ion-card-header class="ion-no-padding ion-padding-horizontal">
  <ion-item-divider class="ion-no-padding">
    <h5>
      <ion-label color="dark" class="ion-margin-start">
        <ion-icon name="{{ icon() }}" item-left class="mb--2px"></ion-icon>
        {{ displayText() }}
        @if (subText()) {
          <small class="text-light-grey"> / {{ subText() }}</small>
        }
      </ion-label>
    </h5>
  </ion-item-divider>
</ion-card-header>
